import type { RouteRecordRaw } from 'vue-router'

// 导入页面组件（懒加载）
const AppLayoutView = () => import('@/views/AppLayoutView.vue')
const QrLogin = () => import('@/views/QrLogin.vue')
const Dashboard = () => import('@/views/Dashboard.vue')
const Assets = () => import('@/views/AssetsView.vue')
const AssetDetail = () => import('@/views/AssetDetailView.vue')
const AssetEdit = () => import('@/views/AssetEditView.vue')
const Usage = () => import('@/views/Usage.vue')
const Analytics = () => import('@/views/AnalyticsView.vue')
const Reminders = () => import('@/views/RemindersView.vue')
const SettingsView = () => import('@/views/SettingsView.vue')
const Categories = () => import('@/views/CategoriesView.vue')
const Tags = () => import('@/views/TagsView.vue')
const Locations = () => import('@/views/LocationsView.vue')

export const routes: RouteRecordRaw[] = [
  // ── 认证路由（无需登录）──────────────────────────────────────────
  {
    path: '/login',
    name: 'Login',
    component: QrLogin,
    meta: { requiresAuth: false, title: '登录' }
  },
  {
    path: '/qr',
    name: 'QrLogin',
    component: QrLogin,
    meta: { requiresAuth: false, title: '扫码登录' }
  },

  // ── 主功能路由（带持久侧边栏导航）────────────────────────────────
  {
    path: '/',
    component: AppLayoutView,
    redirect: '/dashboard',
    meta: { requiresAuth: true },
    children: [
      // 看板
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: { requiresAuth: true, title: '数据看板' }
      },
      // 资产管理
      {
        path: 'assets',
        name: 'Assets',
        component: Assets,
        meta: { requiresAuth: true, title: '资产管理' }
      },
      {
        path: 'assets/new',
        name: 'AssetCreate',
        component: AssetEdit,
        meta: { requiresAuth: true, title: '新增资产', mode: 'create' }
      },
      {
        path: 'assets/:id',
        name: 'AssetDetail',
        component: AssetDetail,
        meta: { requiresAuth: true, title: '资产详情' }
      },
      {
        path: 'assets/:id/edit',
        name: 'AssetEdit',
        component: AssetEdit,
        meta: { requiresAuth: true, title: '编辑资产', mode: 'edit' }
      },
      // 使用记录
      {
        path: 'usage',
        name: 'Usage',
        component: Usage,
        meta: { requiresAuth: true, title: '使用记录' }
      },
      // 数据分析
      {
        path: 'analytics',
        name: 'Analytics',
        component: Analytics,
        meta: { requiresAuth: true, title: '数据分析' }
      },
      // 到期提醒
      {
        path: 'reminders',
        name: 'Reminders',
        component: Reminders,
        meta: { requiresAuth: true, title: '到期提醒' }
      },
      // 设置
      {
        path: 'settings',
        name: 'Settings',
        component: SettingsView,
        meta: { requiresAuth: true, title: '设置' }
      },
      {
        path: 'settings/categories',
        name: 'SettingsCategories',
        component: Categories,
        meta: { requiresAuth: true, title: '分类管理' }
      },
      {
        path: 'settings/tags',
        name: 'SettingsTags',
        component: Tags,
        meta: { requiresAuth: true, title: '标签管理' }
      },
      {
        path: 'settings/locations',
        name: 'SettingsLocations',
        component: Locations,
        meta: { requiresAuth: true, title: '位置管理' }
      },
      // 管理员
      {
        path: 'admin',
        redirect: { name: 'AdminOverview' },
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'admin/overview',
        name: 'AdminOverview',
        component: () => import('@/views/AdminOverview.vue'),
        meta: { requiresAuth: true, requiresAdmin: true, title: '运营看板' }
      },
      {
        path: 'admin/ai',
        name: 'AdminAI',
        component: () => import('@/views/AdminAI.vue'),
        meta: { requiresAuth: true, requiresAdmin: true, title: 'AI 管理' }
      }
    ]
  },

  // ── 兜底 ────────────────────────────────────────────────────────
  {
    path: '/:pathMatch(.*)*',
    redirect: '/dashboard'
  }
]
